import * as React from "react"
import { Link as RLink, useNavigate, useParams } from "react-router-dom"
import { useQuery } from "react-query"
import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"
import { Stack, Flex, Progress, Divider, Text, Spinner, Center, Link, IconButton } from "@chakra-ui/react"
import { FiExternalLink } from "react-icons/fi"

import { humanize } from "../lib/helpers/text"
import { BikeEntity } from "../lib/types/bike"
import { LocationLink } from "./LocationLink"
import { useFeatFlags } from "./providers/FeatFlagProvider"

dayjs.extend(relativeTime)

export const TripsBikeInfo = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const { bike_sn_as_name_extension, asset_deployed_state } = useFeatFlags()

  const { data: bike } = useQuery<BikeEntity, string>(`bicycles/${id}/`)

  const color = {
    available: "blue.500",
    rented: "green800",
    in_maintenance: "gray.500",
    retired: "gray.500",
    unrecoverable: "orange.800",
    lost: "red.800",
    unknown: "gray.500",
    ...(asset_deployed_state?.visible && { deployed: "brown.600" }),
  }

  if (!bike)
    return (
      <Center h={131}>
        <Spinner />
      </Center>
    )
  return (
    <Stack spacing={3}>
      <Stack spacing={0}>
        <Flex align="center">
          <Link as={RLink} to={`/assets/${bike.uuid}`} fontSize="1.2rem" fontWeight="600">
            {bike.name}
            {bike.serial_number &&
              bike_sn_as_name_extension?.visible &&
              bike.name.toUpperCase() !== bike.serial_number.toUpperCase() &&
              `.${bike.serial_number}`}
          </Link>
          <IconButton
            ml={3}
            aria-label="go to asset"
            icon={<FiExternalLink />}
            boxSize="30px"
            cursor="pointer"
            minW="30px"
            p={2}
            variant="ghost"
            onClick={() => navigate(`/assets/${bike.uuid}`)}
          />
        </Flex>
        {/* shows serial number explicitly */}
        {/* {bike.serial_number && bike_sn_as_name_extension?.visible
          && bike.name.toUpperCase() !== bike.serial_number.toUpperCase() && (
          <Text marginTop={-1} color="gray.800" fontSize="0.8rem">
            {bike.serial_number}
          </Text>
        )} */}
      </Stack>
      <Text color="gray.800" fontSize="0.8rem">
        State:{" "}
        <Text as="span" color={color[bike.state]}>
          {humanize(bike.state)}
        </Text>
      </Text>
      {bike.latitude && bike.longitude && (
        <LocationLink obj={{ latitude: bike.latitude, longitude: bike.longitude }} />
      )}
      <Flex align="center" justify="space-between">
        <Flex align="center">
          <Text fontSize="0.7rem">{Math.ceil(bike.state_of_charge || 0)}%</Text>
          <Progress
            size="sm"
            ml={1}
            h="5px"
            borderRadius="md"
            colorScheme={
              !bike.state_of_charge || bike.state_of_charge < 10
                ? "red"
                : bike.state_of_charge < 50
                ? "orange"
                : "green"
            }
            w="80px"
            value={bike.state_of_charge || 0}
          />
        </Flex>
        <Flex align="center" textAlign="right">
          <Text fontSize="0.7rem">Updated:</Text>
          <Text fontSize="0.7rem" ml={1} color="gray.600" whiteSpace="nowrap">
            {bike.last_cellular_update ? dayjs(bike.last_cellular_update).fromNow() : "N/A"}
          </Text>
        </Flex>
      </Flex>
      <Divider />
    </Stack>
  )
}
